import React, { useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css"; // Import Swagger UI CSS
import "./custom.css"; // Custom CSS for responsive design

// Define the API keys as a union type
type ApiKey = "search" | "toolbox";

const APIWebReferenceReferencePage: React.FC = () => {
  // Set the initial API selection and explicitly type it as 'ApiKey'
  const [selectedApi, setSelectedApi] = useState<ApiKey>("search");

  // Define the API URLs, typed with ApiKey
  const apiUrls: Record<ApiKey, string> = {
    search: "https://data.sustamizer.com/search/swagger/v2/swagger.json",
    toolbox: "https://toolbox.sustamizer.com/v1/docs/swagger.json",
  };

  // Function to handle API selection in the horizontal menu
  const handleApiSelection = (apiKey: ApiKey) => {
    setSelectedApi(apiKey);
  };

  return (
    <div className="api-reference-page">
      {/* Horizontal Menu with API Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex flex-wrap justify-center space-x-4 md:space-x-8">
          <li
            className={`cursor-pointer ${
              selectedApi === "search" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleApiSelection("search")}
          >
            Search API
          </li>
          <li
            className={`cursor-pointer ${
              selectedApi === "toolbox" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleApiSelection("toolbox")}
          >
            Toolbox API
          </li>
        </ul>
      </nav>

      {/* Main Content (Swagger UI + Request/Response examples) */}
      <div className="content-area w-full p-6 text-left">
        <h1 className="text-3xl font-bold mb-6">API Documentation</h1>

        {/* Swagger UI renders dynamically based on selected API */}
        <SwaggerUI url={apiUrls[selectedApi]} />
      </div>
    </div>
  );
};

export default APIWebReferenceReferencePage;
